var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CREATED_BY_US, TRANSCEIVER_STOPPED_FIELD, uuid } from "../../Common";
import { log } from "../../log";
class StreamStats {
    /*
    private static KEEP = {
      "inbound-rtp": {
        framesDecoded: true,
        lastPacketReceivedTimestamp: true,
        averageRtcpInterval: true,
        fecPacketsReceived: true,
        bytesReceived: true,
        packetsFailedDecryption: true,
        packetsDuplicated: true
      },
      "outbound-rtp": {
        lastPacketSentTimestamp: true,
        targetBitrate: true,
        framesEncoded: true,
        totalEncodeTime: true,
        averageRtcpInterval: true
      },
      "remote-inbound-rtp": {
        roundTripTime: true,
        fractionLost: true
      },
      "remote-outbound-rtp": {
        remoteTimestamp: true
      },
      csrc: {
        contributorSsrc: true,
        packetsContributedTo: true,
        audioLevel: true
      },
      sender: {
        // kind audio
        echoReturnLoss: true,
        echoReturnLossEnhancement: true,
        totalSamplesSent: true,
  
        // kind video
        framesCaptured: true,
        framesSent: true,
        hugeFramesSent: true,
        keyFramesSent: true
      },
      receiver: {
        // kind audio
        estimatedPlayoutTimestamp: true,
        jitterBufferDelay: true,
        jitterBufferEmittedCount: true,
        totalSamplesReceived: true,
        concealedSamples: true,
        concealmentEvents: true,
  
        // kind video
        framesCaptured: true,
        framesSent: true,
        hugeFramesSent: true,
        keyFramesSent: true
      },
      transport: {
        packetsSent: true,
        packetsReceived: true,
        bytesSent: true,
        bytesReceived: true
      },
      "candidate-pair": {
        packetsSent: true,
        packetsReceived: true,
        bytesSent: true,
        bytesReceived: true,
        lastPacketSentTimestamp: true,
        lastPacketReceivedTimestamp: true,
        firstRequestTimestamp: true,
        lastRequestTimestamp: true,
        lastResponseTimestamp: true,
        totalRoundTripTime: true,
        currentRoundTripTime: true,
        availableOutgoingBitrate: true,
        availableIncomingBitrate: true,
        circuitBreakerTriggerCount: true,
        requestsReceived: true,
        requestsSent: true,
        responsesReceived: true,
        responsesSent: true,
        retransmissionsReceived: true,
        retransmissionsSent: true,
        consentRequestsSent: true,
        consentExpiredTimestamp: true
      },
  
      // chrome specific stats
      ssrc: {
        bytesReceived: true,
        framesDecoded: true,
        googCaptureStartNtpTimeMs: true,
        googCurrentDelayMs: true,
        googDecodeMs: true,
        googFirsSent: true,
        googFirstFrameReceivedToDecodedMs: true,
        googFrameHeightReceived: true,
        googFrameRateDecoded: true,
        googFrameRateOutput: true,
        googFrameRateReceived: true,
        googJitterBufferMs: true,
        googMaxDecodeMs: true,
        googMinPlayoutDelayMs: true,
        googNacksSent: true,
        googPlisSent: true,
        googRenderDelayMs: true,
        googTargetDelayMs: true,
        packetsLost: true,
        packetsReceived: true,
        qpSum: true,
        ssrc: true
      },
      googCandidatePair: {
        bytesReceived: true,
        bytesSent: true,
        consentRequestsSent: true,
        packetsDiscardedOnSend: true,
        packetsSent: true,
        requestsReceived: true,
        requestsSent: true,
        responsesReceived: true,
        responsesSent: true
      },
      VideoBwe: {
        googActualEncBitrate: true,
        googAvailableReceiveBandwidth: true,
        googAvailableSendBandwidth: true,
        googBucketDelay: true,
        googRetransmitBitrate: true,
        googTargetEncBitrate: true,
        googTransmitBitrate: true
      }
    };
    */
    constructor(pc, keep) {
        this.pc = pc;
        this.keep = keep;
        this.defaultInterval = 900;
        this.stats = {
            timeseries: [],
            instance: {},
        };
    }
    setHandler(handler) {
        this.notifier = handler;
    }
    enable(interval) {
        this.intervalId = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            this.processTimeseries(yield this.pc.getStats(null));
            if (this.notifier) {
                this.notifier();
            }
        }), interval || this.defaultInterval);
    }
    processInstance(report) {
        report.forEach((dict) => {
            this.stats.instance[dict.id] = Object.assign({}, dict);
        });
    }
    processTimeseries(report) {
        report.forEach((dict) => {
            try {
                if (dict.type in this.keep) {
                    // filters
                    if (dict.type === "googCandidatePair" &&
                        dict.googActiveConnection === false) {
                        return;
                    }
                    else if (dict.type === "candidate-pair" &&
                        dict.nominated === false) {
                        return;
                    }
                    const fields = Object.entries(dict)
                        .filter(([key]) => this.keep[dict.type][key] === true)
                        .reduce((acc, [key, value]) => {
                        acc[key] = value;
                        return acc;
                    }, {});
                    if (Object.keys(fields).length === 0) {
                        return;
                    }
                    this.stats.timeseries.push({
                        measurement: dict.type,
                        timestamp: dict.timestamp instanceof Date
                            ? dict.timestamp.getTime()
                            : dict.timestamp,
                        tags: {
                            id: dict.id,
                        },
                        fields,
                    });
                }
            }
            catch (error) {
                log.debug(`rtc stats report key:${dict.type} got error ${error.message}`);
            }
        });
    }
    // add new stats report to stats; compute delta of values, stringified
    // when joining array these chars cannot be used as separator
    // + = <space> : , - _ . [ ]
    // arbitrarily use <tab> for separator
    // get copy of stats and clear records
    collectMeasurements() {
        return __awaiter(this, void 0, void 0, function* () {
            const copy = this.stats.timeseries;
            this.stats.timeseries = [];
            return {
                timeseries: copy,
            };
        });
    }
    collectInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            this.processInstance(yield this.pc.getStats());
            return {
                instance: this.stats.instance,
            };
        });
    }
    disable() {
        if (this.intervalId >= 0) {
            window.clearInterval(this.intervalId);
            this.intervalId = -1;
        }
    }
}
/**
 * Handles the rtc peer connection, its data and registers event handlers
 */
export class StreamSession {
    /**
     * Handles only the rtc logic and the data it needs
     * @param context - the context call state
     */
    constructor(options = {}) {
        this.id = uuid();
        this.negotationNeeded = false;
        this.notVirginSenders = [];
        this.handlers = {};
        this.eventLog = [];
        this.options = options;
    }
    evlog(type, data) {
        this.eventLog.push({ type, at: Date.now(), data });
    }
    enableStats(interval) {
        if (this.pc) {
            this.evlog("stats", { enabled: true, interval: 900 });
            this.statsLogger.enable(interval);
        }
    }
    getLastLogs() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                events: this.eventLog.splice(0),
                report: yield this.statsLogger.collectMeasurements(),
            };
        });
    }
    getAllLogs() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                events: this.eventLog.splice(0),
                report: Object.assign(Object.assign({}, (yield this.statsLogger.collectMeasurements())), (yield this.statsLogger.collectInstance())),
            };
        });
    }
    disableStats() {
        this.evlog("stats", { enabled: false });
        this.statsLogger.disable();
    }
    // for mute, hold use
    setTrackKindEnabled(kind, enabled) {
        const changeTrack = (track) => {
            if (track && kind.includes(track.kind)) {
                track.enabled = enabled;
            }
        };
        if (this.pc) {
            this.pc.getSenders().forEach((sender) => changeTrack(sender.track));
            this.pc.getReceivers().forEach((receiver) => changeTrack(receiver.track));
        }
        // these are just in case tracks differ with those of PC
        if (this.localMediaStream) {
            this.localMediaStream.getTracks().forEach(changeTrack);
        }
        if (this.remoteMediaStream) {
            this.remoteMediaStream.getTracks().forEach(changeTrack);
        }
    }
    /**
     * Resolves mediastream property to that of options or navigator
     */
    resolveMediaStream(mediaConstraints) {
        return __awaiter(this, void 0, void 0, function* () {
            const createdByUs = !this.localMediaStream;
            this.localMediaStream =
                this.localMediaStream ||
                    (yield navigator.mediaDevices.getUserMedia(mediaConstraints || {
                        audio: true,
                        video: true,
                    }));
            if (createdByUs) {
                this.localMediaStream.getTracks().forEach((track) => {
                    track[CREATED_BY_US] = true;
                });
            }
        });
    }
    on(name, handler) {
        if (!this.pc) {
            return;
        }
        if (name === "track") {
            this.pc.addEventListener(name, (event) => {
                if (!this.remoteMediaStream) {
                    this.remoteMediaStream =
                        event.streams[0] || new MediaStream([event.track]);
                }
                else if (this.remoteMediaStream !== event.streams[0]) {
                    this.mediaReplaceTrack(event.track, this.remoteMediaStream);
                }
                handler(Object.assign(Object.assign({}, event), { streams: [this.remoteMediaStream] }));
            });
        }
        else if (name === "stats") {
            this.statsLogger.setHandler(handler);
        }
        else {
            this.pc.addEventListener(name, handler);
        }
    }
    mediaReplaceTrack(track, media) {
        const oldTrack = track.kind === "audio"
            ? media.getAudioTracks()[0]
            : media.getVideoTracks()[0];
        if (oldTrack && oldTrack.id !== track.id) {
            oldTrack[CREATED_BY_US] && oldTrack.stop();
            media.removeTrack(oldTrack);
        }
        if (!oldTrack || oldTrack.id !== track.id) {
            media.addTrack(track);
        }
    }
    fillMedia(mediastream) {
        mediastream.getTracks().forEach((t) => {
            this.fillTrack(t.kind, t, mediastream);
        });
    }
    fillTrack(kind, track, mediastream) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            const init = mediastream
                ? { streams: [mediastream] }
                : {};
            let transceiver = this.resolveSender(kind);
            const addTrack = () => {
                const sender = this.pc.addTrack(track, mediastream);
                const [tran] = this.pc
                    .getTransceivers()
                    .filter((t) => t.sender === sender);
                tran.direction = "sendonly";
            };
            if (!transceiver) {
                try {
                    transceiver = this.pc.addTransceiver(track || kind, Object.assign({ direction: "sendonly" }, init));
                }
                catch (error) {
                    addTrack();
                }
            }
            else if (this.notVirginSenders.includes(transceiver)) {
                yield transceiver.sender.replaceTrack(track);
            }
            else {
                addTrack();
            }
        });
    }
    resolveSender(kind) {
        for (const t of this.pc.getTransceivers()) {
            const track = t.sender.track || t.receiver.track;
            if (!t[TRANSCEIVER_STOPPED_FIELD] && !!track && track.kind === kind) {
                return t;
            }
        }
        return null;
    }
    setDirection(kinds, send, receive) {
        this.pc.getTransceivers().forEach((t) => {
            if (!t[TRANSCEIVER_STOPPED_FIELD] &&
                !!t.direction &&
                !!t.receiver.track &&
                kinds.includes(t.receiver.track.kind)) {
                let dir = t.direction;
                if (send === true && receive === true) {
                    dir = "sendrecv";
                }
                else if (send === true && receive === false) {
                    dir = "sendonly";
                }
                else if (send === false && receive === true) {
                    dir = "recvonly";
                }
                else if (send === false && receive === false) {
                    dir = "inactive";
                }
                if (dir !== t.direction) {
                    t.direction = dir;
                }
            }
        });
    }
    /**
     * Creates a new RTCPeerConnection and adds required listeners
     */
    create(configuration) {
        return __awaiter(this, void 0, void 0, function* () {
            // just to make sure resources are cleaned
            this.close();
            debugRTCConfiguration(configuration);
            this.evlog("created", { configuration });
            this.pc = new RTCPeerConnection(Object.assign({}, configuration));
            this.setListeners();
            this.statsLogger = new StreamStats(this.pc, this.options.statsList);
        });
    }
    /**
     * Creates offer and calls setLocalDescription
     */
    offer() {
        return __awaiter(this, void 0, void 0, function* () {
            const offer = yield this.pc.createOffer();
            if (this.options.fixRtpExtensionIds) {
                offer.sdp = fixRtpExtensionIds(offer.sdp);
            }
            // offer.sdp = setupBandwidth(offer.sdp, 2000, 2000, 2000);
            this.evlog(offer.type, { sdp: offer.sdp });
            yield this.pc.setLocalDescription(offer);
        });
    }
    /**
     * calls peer connection setRemoteDescription
     */
    answer() {
        return __awaiter(this, void 0, void 0, function* () {
            const answer = yield this.pc.createAnswer();
            this.evlog(answer.type, { sdp: answer.sdp });
            yield this.pc.setLocalDescription(answer);
        });
    }
    /**
     * calls peer connection setRemoteDescription
     */
    setSdp(sdp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.evlog("remote-sdp", Object.assign({}, sdp));
                yield this.pc.setRemoteDescription(sdp);
            }
            catch (error) {
                this.evlog("error", { info: error.message });
                throw error;
            }
        });
    }
    setListeners() {
        const listeners = {
            negotiationneeded: (E) => {
                this.evlog(E.type);
                this.negotationNeeded = true;
                this.notVirginSenders = this.pc
                    .getTransceivers()
                    .filter((tran) => this.notVirginSenders.includes(tran) ||
                    tran[TRANSCEIVER_STOPPED_FIELD] ||
                    tran.sender.track !== null ||
                    (tran.currentDirection !== null &&
                        tran.currentDirection.includes("send")));
            },
            onstatsended: (E) => {
                this.evlog(E.type, { report: E.report });
            },
            datachannel: (E) => {
                this.evlog(E.type);
            },
            track: (E) => {
                this.evlog(E.type, {
                    streams: E.streams,
                    track: E.track,
                    transceiver: E.transceiver,
                });
            },
            onicecandidateerror: (E) => {
                this.evlog(E.type, Object.assign({}, E));
            },
            icecandidate: (E) => {
                this.evlog(E.type, {
                    candidate: E.candidate ? E.candidate.toJSON() : null,
                });
            },
            signalingstatechange: (E) => {
                this.evlog(E.type, { signalingState: this.pc.signalingState });
                if (this.pc.signalingState === "stable") {
                    this.negotationNeeded = false;
                }
            },
            icegatheringstatechange: (E) => {
                this.evlog(E.type, {
                    iceGatheringState: this.pc.iceGatheringState,
                });
            },
            connectionstatechange: (E) => {
                this.evlog(E.type, {
                    connectionState: this.pc.connectionState,
                });
            },
            iceconnectionstatechange: (E) => {
                this.evlog(E.type, {
                    iceConnectionState: this.pc.iceConnectionState,
                });
            },
        };
        Object.entries(listeners).forEach((entry) => this.pc.addEventListener(...entry));
    }
    /**
     * close connection
     */
    close() {
        if (this.pc) {
            this.disableStats();
            this.pc.close();
        }
    }
}
function fixRtpExtensionIds(sdp) {
    const genericExtRegExp = /^a=extmap:(\\d+) (.+)/;
    const videoOrientationExtRegExp = /^a=extmap:(\\d+) urn:3gpp:video-orientation/;
    const playoutDelayExtRegExp = /^a=extmap:(\\d+) http:\/\/www.webrtc.org\/experiments\/rtp-hdrext\/playout-delay/;
    const audioLevelExtRegExp = /^a=extmap:(\\d+) urn:ietf:params:rtp-hdrext:ssrc-audio-level/;
    return sdp
        .split("\n")
        .reduce((result, line) => {
        // allow audio level extension
        if (audioLevelExtRegExp.test(line)) {
            result.push("a=extmap:1 urn:ietf:params:rtp-hdrext:ssrc-audio-level");
        }
        // allow video orientation extension
        if (videoOrientationExtRegExp.test(line)) {
            result.push("a=extmap:2 urn:3gpp:video-orientation");
        }
        // allow playout delay
        if (playoutDelayExtRegExp.test(line)) {
            result.push("a=extmap:3 http://www.webrtc.org/experiments/rtp-hdrext/playout-delay");
        }
        // dissallow all other extensions
        if (!genericExtRegExp.test(line)) {
            result.push(line);
        }
        // allow everything else in sdp
        return result;
    }, [])
        .join("\n");
}
function setupBandwidth(sdp, minBitrate, startBitrate, maxBitrate) {
    return sdp
        .split("\n")
        .reduce((result, line) => {
        if (/^a=fmtp:\d*/.test(line)) {
            result.push(`${line};x-google-max-bitrate=${maxBitrate};x-google-min-bitrate=${minBitrate};x-google-start-bitrate=${startBitrate}`);
        }
        else if (/^a=mid:(0|video)/.test(line)) {
            result.push(line);
            result.push(`b=AS:${maxBitrate}`);
        }
        else {
            result.push(line);
        }
        return result;
    }, [])
        .join("\n");
}
// returns filtered ice candidates according to filter value in session storage with key auvious::rtc::iceCandidateFilter
// usefull for debugging/troubleshooting ice candidate issues
export function debugIceCandidateFilter(candidates) {
    // must contain space separated list of allowable candidate types e.g. "srflx relay"
    const iceCandidateFilterKey = "auvious::rtc::iceCandidateFilter";
    try {
        const storage = window.sessionStorage;
        const iceCandidateFilter = storage.getItem(iceCandidateFilterKey);
        const allowableCandidateTypes = iceCandidateFilter
            ? iceCandidateFilter.split(" ")
            : [];
        if (allowableCandidateTypes.length > 0) {
            return candidates.filter((c) => {
                if (!c.candidate) {
                    return true;
                }
                const includes = allowableCandidateTypes.includes(c.candidate.type);
                log.debug(`candidate type ${c.candidate.candidate} is ${includes ? "allowed" : "filtered"}`);
                return includes;
            });
        }
    }
    catch (error) {
        log.error(`error getting ice candidate filter ${error.message}`);
    }
    return candidates;
}
// applies ice server filtering and removes any entries not matching filter value in session storage with key auvious::rtc::iceServerFilter
// also applies ice transport policy value in session storage with key auvious::rtc::iceTransportPolicy
// usefull for debugging/troubleshooting ice server issues
function debugRTCConfiguration(configuration) {
    const iceServerFilter = "auvious::rtc::iceServerFilter";
    try {
        const storage = window.sessionStorage;
        const iceServerFilterValue = storage.getItem(iceServerFilter);
        if (iceServerFilterValue) {
            configuration.iceServers = configuration.iceServers.filter((s) => {
                // if urls is string then check if it matches filter value
                if (typeof s.urls === "string" &&
                    s.urls.includes(iceServerFilterValue)) {
                    return true;
                }
                else if (Array.isArray(s.urls)) {
                    // if urls contains string matching filter value then keep
                    const urls = s.urls.filter((u) => u.includes(iceServerFilterValue));
                    if (urls.length > 0) {
                        return true;
                    }
                }
                return false;
            });
            // now remove any urls that don't match filter value
            configuration.iceServers = configuration.iceServers.map((s) => {
                if (Array.isArray(s.urls)) {
                    const urls = s.urls.filter((u) => u.includes(iceServerFilterValue));
                    log.debug("filtered ice server urls", urls);
                    return Object.assign(Object.assign({}, s), { urls });
                }
                return s;
            });
        }
        // now if there's a iceTransportPolicy value then apply it
        const iceTransportPolicy = storage.getItem("auvious::rtc::iceTransportPolicy");
        if (iceTransportPolicy) {
            configuration.iceTransportPolicy =
                iceTransportPolicy;
        }
    }
    catch (error) {
        log.error(`error getting ice server filter ${error.message}`);
    }
}
//# sourceMappingURL=index.js.map